<template>
  <PageVC>
    <div class="a-container">
      <template v-if="succeeded">
        <h1 class="a-page-title">Det lykkedes!</h1>
        <div class="a-rich-text a-rich-text--centered">
          <p>Din bordbestilling blev slettet</p>
        </div>
      </template>
      <template v-else>
        <h1 class="a-page-title">Bekræft afbestilling</h1>
        <HUIButton
          :disabled="submitting"
          :spinner="submitting"
          @click="handleConfirmButtonClick"
        >Afbestil</HUIButton>
      </template>
    </div>
  </PageVC>
</template>

<script>
import { HUIButton } from '@/halifax-ui'
import PageVC from '@/containers/PageVC'
import routes from '@/router/routes'
import getQueryStringParam from '@/utils/getQueryStringParam'

export default {
  components: {
    PageVC,
    HUIButton
  },
  data() {
    return {
      submitting: false,
      succeeded: false,
      bookingToken: this.$route.params.bookingToken
    }
  },
  beforeRouteEnter(to, from, next) {
    const bookingToken = to.params.bookingToken

    if (!bookingToken) {
      next(vm => {
        vm.$store.dispatch('toast/ERROR', 'Du har ikke adgang til at se denne side.')
        next({
          name: routes.BOOKING
        })
      })
    } else {
      next()
    }
  },
  methods: {
    handleConfirmButtonClick() {
      this.submitting = true
      this.$store
        .dispatch('booking/CANCEL', this.bookingToken)
        .then(json => {
          this.submitting = false
          this.succeeded = true
        })
        .catch(error => {
          this.$store.dispatch('toast/ERROR', error.message)
          this.submitting = false
        })
    }
  }
}
</script>

<style lang="scss">
</style>
